import { jsxs as g, jsx as i } from "react/jsx-runtime";
import * as s from "react";
import { useState as G, useId as L, useEffect as M } from "react";
import { Z as j } from "../index-Dlw4JYvo.js";
import { u as z } from "../index-DoOsnuB6.js";
import { P as S, c as A } from "../index-D8UDu4KA.js";
import { a as K, c as I } from "../index-eoE_jzLb.js";
import { u as q } from "../index-BZPx6jYI.js";
import { u as T } from "../index-4vbonZJj.js";
import { P as X } from "../index-CRtCLpV2.js";
import { c as w } from "../clsx-OuTLNxxd.js";
import { L as F } from "../Label--mSFXd1M.js";
import '../Checkbox.css';var E = "Checkbox", [Z] = A(E), [$, J] = Z(E), N = s.forwardRef(
  (e, a) => {
    const {
      __scopeCheckbox: t,
      name: o,
      checked: h,
      defaultChecked: r,
      required: d,
      disabled: n,
      value: f = "on",
      onCheckedChange: b,
      form: p,
      ...v
    } = e, [l, C] = s.useState(null), y = z(a, (c) => C(c)), _ = s.useRef(!1), R = l ? p || !!l.closest("form") : !0, [m = !1, P] = K({
      prop: h,
      defaultProp: r,
      onChange: b
    }), D = s.useRef(m);
    return s.useEffect(() => {
      const c = l == null ? void 0 : l.form;
      if (c) {
        const x = () => P(D.current);
        return c.addEventListener("reset", x), () => c.removeEventListener("reset", x);
      }
    }, [l, P]), /* @__PURE__ */ g($, { scope: t, state: m, disabled: n, children: [
      /* @__PURE__ */ i(
        S.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(m) ? "mixed" : m,
          "aria-required": d,
          "data-state": H(m),
          "data-disabled": n ? "" : void 0,
          disabled: n,
          value: f,
          ...v,
          ref: y,
          onKeyDown: I(e.onKeyDown, (c) => {
            c.key === "Enter" && c.preventDefault();
          }),
          onClick: I(e.onClick, (c) => {
            P((x) => u(x) ? !0 : !x), R && (_.current = c.isPropagationStopped(), _.current || c.stopPropagation());
          })
        }
      ),
      R && /* @__PURE__ */ i(
        Q,
        {
          control: l,
          bubbles: !_.current,
          name: o,
          value: f,
          checked: m,
          required: d,
          disabled: n,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(r) ? !1 : r
        }
      )
    ] });
  }
);
N.displayName = E;
var O = "CheckboxIndicator", B = s.forwardRef(
  (e, a) => {
    const { __scopeCheckbox: t, forceMount: o, ...h } = e, r = J(O, t);
    return /* @__PURE__ */ i(X, { present: o || u(r.state) || r.state === !0, children: /* @__PURE__ */ i(
      S.span,
      {
        "data-state": H(r.state),
        "data-disabled": r.disabled ? "" : void 0,
        ...h,
        ref: a,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
B.displayName = O;
var Q = (e) => {
  const { control: a, checked: t, bubbles: o = !0, defaultChecked: h, ...r } = e, d = s.useRef(null), n = q(t), f = T(a);
  s.useEffect(() => {
    const p = d.current, v = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(v, "checked").set;
    if (n !== t && C) {
      const y = new Event("click", { bubbles: o });
      p.indeterminate = u(t), C.call(p, u(t) ? !1 : t), p.dispatchEvent(y);
    }
  }, [n, t, o]);
  const b = s.useRef(u(t) ? !1 : t);
  return /* @__PURE__ */ i(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: h ?? b.current,
      ...r,
      tabIndex: -1,
      ref: d,
      style: {
        ...e.style,
        ...f,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function u(e) {
  return e === "indeterminate";
}
function H(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var U = N, V = B;
const W = "_checkbox_ihrtn_32", Y = "_shouldHighlightOnChecked_ihrtn_32", ee = "_checked_ihrtn_32", te = "_checkboxBox_ihrtn_53", oe = "_indicator_ihrtn_64", re = "_checkboxGroup_ihrtn_83", k = {
  checkbox: W,
  shouldHighlightOnChecked: Y,
  checked: ee,
  checkboxBox: te,
  indicator: oe,
  checkboxGroup: re
}, pe = ({ children: e, className: a, label: t, ...o }) => (!t && !o["aria-label"] && !o["aria-labelledby"] && console.warn(
  "Checkbox group must provide and `aria-label` if no visible `label` prop is provided. If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"
), // `...props` last: the type accepts every fieldset attribute, and only three were forwarded, so
// `disabled` (which should disable every control in the group), `name` and `id` were dropped. The
// two aria props are computed above from `label`, so they are spread first and then overridden
// deliberately when the caller set them and there is no visible label.
/* @__PURE__ */ g(
  "fieldset",
  {
    className: w(k.checkboxGroup, a),
    ...o,
    "aria-label": t ? void 0 : o["aria-label"],
    "aria-labelledby": t ? void 0 : o["aria-labelledby"],
    children: [
      t && /* @__PURE__ */ i("legend", { children: t }),
      e
    ]
  }
)), me = ({
  checked: e,
  children: a,
  className: t,
  onCheckedChange: o,
  shouldHighlightOnChecked: h = !0,
  ...r
}) => {
  const [d, n] = G(e), f = L();
  return M(() => {
    n(e);
  }, [e]), /* @__PURE__ */ g(
    F,
    {
      className: w(
        k.checkbox,
        {
          [k.checked]: d,
          [k.shouldHighlightOnChecked]: h
        },
        t
      ),
      "data-cxy-name": "checkbox",
      id: f,
      children: [
        /* @__PURE__ */ i(
          U,
          {
            "aria-labelledby": f,
            ...r,
            checked: d,
            className: k.checkboxBox,
            onCheckedChange: (b) => {
              o == null || o(b), n(b);
            },
            children: /* @__PURE__ */ i(V, { className: k.indicator, children: /* @__PURE__ */ i(j, { color: "blue", size: "s" }) })
          }
        ),
        a
      ]
    }
  );
};
export {
  me as Checkbox,
  pe as CheckboxGroup
};
